module.exports = __webpack_public_path__ + "img/js.48ac9a14.gif";